import React, { useContext, useEffect, useRef, useState } from "react";
import ThemeModalPortal from "../ThemeModalPortal";
import ItemMaster from "../../../API/APIServices/ItemMaster";
import MyContext from "../../MyContext";
import Transaction from "../../../API/APIServices/Transaction";

const ThemeModalFristComponent = (props) => {
  const {
    isSliderOpen,
    id,
    setShowFirstComponent,
    showFirstComponent,
    eyePower,
    FramePrice,
    ref,
    setSliderOpen,
    SelectedItem,
    TransAccountId,
    setItemMasterRows,
    ReferenceNumber,
    setChangeInData,
    GetProductDataFunction,
    closeAddItemMOdal,
    itemMasterRows,
    Code,
    GenerateCode,
  } = props;

  const { companyData, imageBaseUrl } = useContext(MyContext);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [lensTypeData, setLensTypeData] = useState(null);
  const [headerName, setHeaderName] = useState("Select Lens Type");
  const [transition, setTransition] = useState(false);
  const [lensType, setLenstype] = useState(null);
  const [progressiveMod, setProgressiveMod] = useState(false);

  // console.log("lensTypeData", lensTypeData);


  const [SingleLensModalBox, setSingleLensModalBox] = useState(false);
  const toggleSliderClose = () => {
    setSliderOpen(false);
  };

  useEffect(() => {
    if (!showFirstComponent && !SingleLensModalBox && !eyePower) {
      if (lensType == 3 && !progressiveMod) {
        setHeaderName("Choose Progressive Design (Optional)");
      } else if (lensType == 3 && progressiveMod) {
        setHeaderName("Choose Lenses Thickness (Optional)");
      } else {
        setHeaderName("Choose Lenses Thickness (Optional)");
      }
    } else if (showFirstComponent) {
      setHeaderName("Select Lens Type");
    } else if (SingleLensModalBox) {
      setHeaderName("Choose Lens Package");
    } else if (eyePower) {
      setHeaderName("Eye Power");
    }
  }, [showFirstComponent, SingleLensModalBox, eyePower, progressiveMod]);

  const showModal1 = async (lens) => {
    ;
    if (lens.lensTypeNumber == 7) {
      //   AddToCart(id);
      return;
    } else {
      setLenstype(lens.id);
    }
    setSingleLensModalBox(true);
    setTransition(true);
    setShowFirstComponent(false);
    setTimeout(() => {
      setTransition(false);
    }, 200);
  };

  function generate4DigitCode() {
    return Math.floor(100000 + Math.random() * 900000);
  }

  const fetchLensTypeData = async () => {
    try {
      ;
      // const data = await LensTypeMaster.getLensTypeMaster();
      const data = await ItemMaster.getItemLensProdSetting(id);
      console.log("data", data);
      if (Array.isArray(data)) {
        const mergedLensTypeData = data.flatMap(
          (item) => item.lensTypeMasterDataDTO || []
        );

        const uniqueLensTypeData = Array.from(
          new Map(mergedLensTypeData.map((item) => [item.id, item])).values()
        );
        setLensTypeData(uniqueLensTypeData);
      }
    } catch (error) {
      console.error("Error fetching item data:", error);
    }
  };

  useEffect(() => {
    fetchLensTypeData();
  }, [id]);

  const modalRef = useRef(null);
  const handleBackClk = () => {
    ;
    if (modalRef.current) {
      modalRef.current.goBack(); // Calls the handleBackClick inside ThemeModalPortal
    }
  };

  const AddInCart = async (id, dataItem) => {
    try {
      let updateIndex = 0;
      const newItemData = [];
      const updatedRows = [...itemMasterRows]; // Local copy of state

      for (let i = 0; i < dataItem.length; i++) {
        const filterData = {
          searchTypeId: 4,
          itmId_d2: dataItem[i].d2ItemId,
        };

        const ItemData = await Transaction.GetBarcodeSerialBatchNoForItemFetch(
          filterData
        );

        const targetIndex = updatedRows.findIndex(
          (row, idx) => idx >= updateIndex && row.d1_Id === 0 && row.d2_Id === 0
        );

        if (targetIndex !== -1) {
          const updatedRow = {
            ...updatedRows[targetIndex],
            d1_Id: ItemData.d1_Id || "",
            d2_Id: ItemData.d2_Id || "",
            productName: ItemData.productName || "",
            parentGrp: ItemData.parentGrp2 || "",
            parentGrpName: ItemData.parentGrpName || "",
            productUnitName: ItemData.productUnitName || "",
            productUnit: ItemData.productUnit || "",
            productAltUnit: ItemData.productAltUnit || "",
            unitConvFactor: ItemData.unitConvFactor || "",
            enableBarcode: ItemData.enableBarcode || "",
            defaultBarcode: ItemData.Barcode || "",
            batchNos: ItemData.batchDetails || [],
            taxCategory1: ItemData.taxCategory1 || "",
            taxLimit: ItemData.taxLimit || "",
            taxCategory2: ItemData.taxCategory2 || "",
            hsnCode: ItemData.hsnCode || "",
            shortDescription: "",
            Qty: ItemData.Qty === 0 ? 1 : ItemData.Qty || 1,
            FreeQty: ItemData.FreeQty || "",
            purchasePrice: ItemData.purchasePrice || "",
            purchaseDiscount: ItemData.purchaseDiscount || "",
            saleProfit: ItemData.saleProfit || "",
            salePrice: ItemData.salePrice || "",
            saleDiscount: ItemData.saleDiscount || "",
            itemPrice:
              Number(TransAccountId) === 216
                ? ItemData.salePrice
                : Number(TransAccountId) === 215
                ? ItemData.purchasePrice
                : ItemData.salePrice,
            costPrice: ItemData.costPrice || "",
            mrpPrice: ItemData.mrpPrice || "",
            DiscPer:
              Number(TransAccountId) === 216
                ? ItemData.saleDiscount
                : Number(TransAccountId) === 215
                ? ItemData.purchaseDiscount
                : ItemData.saleDiscount,
            DiscAmt: ItemData.DiscAmt || "",
            TotalAmt: ItemData.TotalAmt || "",
            purPageSalePrice: ItemData.salePrice || "",
            availableQuantity: ItemData.availableQuantity || "",
            lens_Eye: ItemData.lens_Eye || "",
            lens_SPH: ItemData.lens_SPH || "",
            lens_CYL: ItemData.lens_CYL || "",
            lens_AXIS: ItemData.lens_AXIS || "",
            lens_Dia: ItemData.lens_Dia || "",
            lens_Add: ItemData.lens_Add || "",
            enableSerialNo: ItemData.enableSerialNo || "",
            taxCat1_Cgst: ItemData.taxCat1_Cgst || "",
            taxCat1_Sgst: ItemData.taxCat1_Sgst || "",
            taxCat1_Igst: ItemData.taxCat1_Igst || "",
            taxCat1_Cess: ItemData.taxCat1_Cess || "",
            taxCat2_Cgst: ItemData.taxCat2_Cgst || "",
            taxCat2_Sgst: ItemData.taxCat2_Sgst || "",
            taxCat2_Igst: ItemData.taxCat2_Igst || "",
            taxCat2_Cess: ItemData.taxCat2_Cess || "",
            linkedItm: Code,
            LensTypeEf : ItemData.LensTypeEf || ""
          };

          updatedRows[targetIndex] = updatedRow;
          newItemData.push(updatedRow); // Push just the updated row
          updateIndex = targetIndex + 1;
        }
      }

      setItemMasterRows(updatedRows); // Update once
      closeAddItemMOdal();

      if (newItemData.length > 0) {
        ;

        const ProductTempData = await Transaction.SetProductTempDataForMultiple(
          newItemData,
          ReferenceNumber
        );
        ;
        await GenerateCode();
        if (ProductTempData.isSuccess === false) {
          console.log("API call failed. Response:", ProductTempData);
        } else {
          setChangeInData(false);
          console.log("Product Temp Data saved successfully.");
          await GetProductDataFunction();
        }
      }
    } catch (error) {
      console.error("Error in AddInCart:", error);
    }
  };

  return (
    <div className={`${isSliderOpen ? "modal-back" : ""}`}>
      <div className={`slider-container-Right ${isSliderOpen ? "open" : ""}`}>
        <div>
          <div>
            <div className="slider-display-allow">
              <div className="slider-head-gm">
                {!showFirstComponent && (
                  <i
                    onClick={() => {
                      handleBackClk();
                      // showModal1Hide();
                    }}
                    class="fa-solid fa-arrow-left-long slide1-left"
                  ></i>
                )}
                {/* <h2 className="slider-top-head-nm">{headerName}</h2> */}
                <h2
                  className="slider-top-head-nm"
                  dangerouslySetInnerHTML={{ __html: headerName }}
                ></h2>
              </div>
              <div onClick={toggleSliderClose} className="slider-head-gm">
                <i class="fa-solid fa-xmark slider-cross-btn"></i>
              </div>
            </div>
          </div>

          <div className="">
            {showFirstComponent && (
              <div className={`component first ${transition ? "exit" : ""}`}>
                <div className="buywithlens-content">
                  <div className="buywithlens-left">
                    {
                      <>
                        {lensTypeData &&
                          lensTypeData
                            .sort((a, b) => a.exfld1 - b.exfld1)
                            .map((item) => (
                              <div
                                key={item.id}
                                className="buy-with-lens-option-slider-theme3"
                                onClick={() => showModal1(item)}
                              >
                                <div>
                                  <img
                                    src={
                                      item.selectedImageId
                                        ? `${imageBaseUrl}${item.selectedImageId}`
                                        : ""
                                    }
                                    alt={item.name}
                                    className="slider-lens-picture"
                                  />
                                </div>
                                <div className="lens-product-type-x1">
                                  <div
                                    className="lens-option-top-theme3"
                                    // onClick={() => showModal1(item)}
                                  >
                                    <p>{item.name}</p>
                                  </div>
                                  <div
                                    className="lens-option-pararaph-theme3"
                                    // onClick={() => showModal1(item)}
                                  >
                                    {item.shortDescription}
                                  </div>
                                </div>
                                <div className="lens-product-type-x2">
                                  <i className="fa-solid fa-chevron-right lens-type-icon-xl"></i>
                                </div>
                              </div>
                            ))}
                      </>
                    }

                    <div className="cart-btn-price">
                      <div className="slide-head-bar-td-1">
                        <div className="top-subtotal">
                          <div className="slide-sub-amount-bar">
                            SubTotal (Frame)
                          </div>
                          <div className="slide-sub-amount-bar">
                            {" "}
                            {companyData?.currencySymbol}{" "}
                            {SelectedItem?.salePrice}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {isSliderOpen && (
            <ThemeModalPortal
              id={id}
              setShowFirstComponent={setShowFirstComponent}
              showFirstComponent={showFirstComponent}
              lensTypeData={lensTypeData}
              lensType={lensType}
              eyePower={eyePower}
              FramePrice={FramePrice}
              ref={modalRef}
              AddInCart={AddInCart}
              CodeGen={generate4DigitCode}
              setHeaderName={setHeaderName}
              SelectedItem={SelectedItem}
              setLenstype={setLenstype}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ThemeModalFristComponent;
